import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js';
import * as lang from 'vuejs-datepicker/src/locale';

export default {
    name: 'QDatepicker',
    components: {
        Datepicker
    },
    props: {
        id: {
            type: String,
            default: 'q-datepicker'
        },
        value: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: ''
        },
        format: {
            type: String,
            default: 'dd-MMM-yyyy'
        },
        hasToggles: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Choose a date'
        },
        inputClasses: {
            type: [String, Object],
            default: 'input'
        },
        calendarClasses: {
            type: [String, Object],
            default: 'calendar'
        },
        wrapperClasses: {
            type: [String, Object],
            default: 'control'
        },
        maximumView: {
            type: String,
            default: 'year'
        },
        typeable: {
            type: Boolean,
            default: false
        },
        minimumDate: {
            type: Date,
            default: null
        },
        maximumDate: {
            type: Date,
            default: null
        },
        isTodayMin: {
            type: Boolean,
            default: false
        },
        isTodayMax: {
            type: Boolean,
            default: false
        },
        callbackFunction: {
            type: String,
            default: ''
        },
        spinnerElement: {
            type: String,
            default: ''
        },
        browser: {
            type: String,
            default: ''
        },
        condensed: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            locale: this.$i18n.locale === 'zh-CN'
                ? 'zh'
                : this.$i18n.locale,
            languages: lang,
            disabledDates: {
                to: this.minimumDate
                    ? this.$moment(this.minimumDate).toDate()
                    : null,
                from: this.maximumDate
                    ? this.$moment(this.maximumDate).toDate()
                    : null
            },
            isToday: true,
            currentDate: this.value,
            prevDisabled: true,
            nextDisabled: false,
            isOpen: false,
            dateFormat: 'MM/DD/YYYY',
            today: ''
        };
    },
    methods: {
        checkToday(today) {
            let actualDay = today.format('D');
            let actualMonth = today.format('MMMM');
            let days = this.$el.getElementsByClassName('day');
            let monthYear = this.$el.getElementsByClassName(
                'day__month_btn'
            )[0];
            let month = monthYear.textContent.split(' ')[0];

            if (month === actualMonth) {
                for (let i = 0, daysLength = days.length; i < daysLength; i++) {
                    if (
                        days[i].classList.contains('today') &&
                        parseInt(days[i].textContent) !== parseInt(actualDay)
                    ) {
                        days[i].classList.remove('today');
                    }

                    if (parseInt(days[i].textContent) === parseInt(actualDay)) {
                        days[i].classList.add('today');
                    }
                }
            }
        },
        evaluateClick(e) {
            let target = e.target;
            let datepicker = this.$el;

            do {
                if (target === datepicker) {
                    return;
                }
                target = target.parentNode;
            } while (target);

            this.isOpen = false;
        },
        toggleResetToTodayLink(date) {
            let todayDate = this.$moment().format(this.dateFormat);
            let currentDateMilli = this.$moment(date).valueOf();
            let prevDay = this.$moment(currentDateMilli).subtract(1, 'days');
            let prevDateMilli = prevDay.valueOf();
            let nextDay = this.$moment(currentDateMilli).add(1, 'days');
            let nextDateMilli = nextDay.valueOf();

            // Get actual selected date month, day, and year to compare to $moment today.
            let currentDate = new Date(date);
            let month = currentDate.getUTCMonth() + 1;
            let day = currentDate.getUTCDate();
            let year = currentDate.getUTCFullYear();
            let dateString =
                (month < 10 ? '0' : '') +
                month +
                '/' +
                (day < 10 ? '0' : '') +
                day +
                '/' +
                year;

            // If the date fits between the timeline.
            if (this.minimumDate) {
                let minimumDateMilli = this.$moment(this.minimumDate).valueOf();
                this.prevDisabled = !(
                    currentDateMilli >= minimumDateMilli &&
                    prevDateMilli >= minimumDateMilli
                );
            }

            // If maximum date exists, determine if current and tomorrow fit.
            if (this.maximumDate) {
                let maximumDateMilli = this.$moment(this.maximumDate).valueOf();
                this.nextDisabled = !(
                    currentDateMilli <= maximumDateMilli &&
                    nextDateMilli <= maximumDateMilli
                );
            }

            this.isOpen = false;

            // This handles qv2 call to the component.
            if (this.callbackFunction) {
                window[this.callbackFunction](currentDate);
            } else {
                // This handles passing back to a parent component.
                this.$emit('update:modelValue', currentDate);
            }

            setTimeout(() => {
                this.isToday = dateString === todayDate;
                this.checkToday(this.$moment());
            }, 600);
        },
        toggleOpen(e) {
            if (e.target.tagName.toLowerCase() === 'input') {
                this.isOpen = !this.isOpen;
            }
        },
        resetToToday() {
            this.currentDate = new Date(this.$moment().format(this.dateFormat));
            this.toggleResetToTodayLink(this.currentDate);
            document.getElementById(this.id).click();
        },
        decrementDay(e) {
            e.preventDefault();
            if (
                !this.$el
                    .getElementsByClassName('prev-day')[0]
                    .classList.contains('disabled')
            ) {
                let currentDate = new Date(this.currentDate);
                currentDate.setDate(currentDate.getDate() - 1);

                this.currentDate = this.$moment(currentDate).toDate();
                this.toggleResetToTodayLink(this.currentDate);
            }
        },
        incrementDay(e) {
            e.preventDefault();
            if (
                !this.$el
                    .getElementsByClassName('next-day')[0]
                    .classList.contains('disabled')
            ) {
                let currentDate = new Date(this.currentDate);
                currentDate.setDate(currentDate.getDate() + 1);

                this.currentDate = this.$moment(currentDate).toDate();
                this.toggleResetToTodayLink(this.currentDate);
            }
        }
    },
    watch: {
        minimumDate() {
            // Make sure that the disabled dates are updated.
            this.disabledDates.to = this.minimumDate
                ? this.$moment(this.minimumDate).toDate()
                : null;

            // If the new minimum date is after the current date,
            // we need to update the current date to the minimum date.
            if (
                this.$moment(this.minimumDate) > this.$moment(this.currentDate)
            ) {
                this.currentDate = this.$moment(this.minimumDate).format(
                    this.dateFormat
                );
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.evaluateClick);

        this.currentDate = this.value
            ? this.$moment(this.value).format(this.dateFormat)
            : this.$moment().format(this.dateFormat);

        let today = this.$moment();
        this.today = today.format(this.dateFormat);

        if (this.isTodayMin) {
            this.disabledDates.to = new Date(this.today);
            this.minimumDate = this.disabledDates.to;
        }

        if (this.isTodayMax) {
            this.disabledDates.from = new Date(this.today);
            this.maximumDate = this.disabledDates.from;
        }

        // Check to see if the appropriate day is marked today.
        setTimeout(() => {
            this.checkToday(today);
        }, 600);
    }
};
